import { connect } from "react-redux";
import injectIntl from "../../../../../common/helpers/injectIntl";

import { showNotification } from "../../../../store/notification/actions";
import { IStateTree } from "../../../../store/interfaces";
import { IUser } from "../../../../store/user/models";

import LoadableComponent from "./lazy";

const mapStateToProps = ({ user }: IStateTree) => ({ user: user as IUser });

export default connect(mapStateToProps, { showNotification })(injectIntl(LoadableComponent));
